"use strict";
module.exports = {
    defaultDeliveryDays: {
        mondayOpen: true,
        tuesdayOpen: true,
        wednesdayOpen: true,
        thursdayOpen: true,
        fridayOpen: true,
        saturdayOpen: false,
        sundayOpen: false,
    },
    defaultSelectedDeliveryRules: [
        {
            selectedRoute: { weekday: 'mon' },
        },
        {
            selectedRoute: { weekday: 'tue' },
        },
        {
            selectedRoute: { weekday: 'wed' },
        },
        {
            selectedRoute: { weekday: 'thu' },
        },
        {
            selectedRoute: { weekday: 'fri' },
        },
    ],
    defaultDeliveryRules: [
        {
            orderBy: { time: '13:00', daysBefore: 3 },
            delivery: { weekday: 'mon' },
        },
        {
            orderBy: { time: '13:00', daysBefore: 1 },
            delivery: { weekday: 'tue' },
        },
        {
            orderBy: { time: '13:00', daysBefore: 1 },
            delivery: { weekday: 'wed' },
        },
        {
            orderBy: { time: '13:00', daysBefore: 1 },
            delivery: { weekday: 'thu' },
        },
        {
            orderBy: { time: '13:00', daysBefore: 1 },
            delivery: { weekday: 'fri' },
        },
    ],
};
